<ng-lottie [options]="options" [width]="width" [height]="height"></ng-lottie>